import { StockInModeEnum } from "./stock-in-mode-enum";

export const stockInModeLabel = {
  [StockInModeEnum.FULL]: "Dikembalikan Sepenuhnya",
  [StockInModeEnum.PARTIAL]: "Dikembalikan Sebagian",
  [StockInModeEnum.NONE]: "Tidak Dikembalikan",
};
